export const featureCardsHeading = {
  part_payment: "Unlock to setup payment instalments",
  customer_auto_debit: "Unlock to setup auto-debit payments",
  branded_community_paid_posts:
    "Upgrade plan to ‘Premium’ to unlock Paid Posts!",
};

export const featureCardsDescription = {
  part_payment:
    "Enable your customers to book with a small fee and pay rest in instalments",
  customer_auto_debit:
    "Enable to automate timely payment renewals from your customers",
  segment_publish:
    "Upgrade plan to preview customers and to publish the segment",
  fb_pixel: "Upgrade plan to add custom Pixel and Access Token",
  view_user_feedbacks:
    "Upgrade plan to unlock feedbacks to manage your customer reviews",
};
